// extracted by mini-css-extract-plugin
export default {"fill":"RyeIcon_fill__IkuzN"};